// extracted by mini-css-extract-plugin
export default {"banner":"HeroBanner_banner__dAgKv","title":"HeroBanner_title__ayDrs","body":"HeroBanner_body__1RqaF","phone":"HeroBanner_phone__fF6Iu"};